import styled from '@emotion/styled';

export const StyledChatFooterNew = styled.div`
    border-top: 1px solid #f5f5f5;
    justify-content: center;
    box-sizing: border-box;
    align-items: center;
    height: fit-content;
    position: absolute;
    min-height: 80px;
    display: flex;
    z-index: 100;
    width: 100%;
    bottom: 0;
    left: 0;
`;
